/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'

class BottomBtn extends React.Component {
    /*const btnContent = {
     text: '添加管理员',
     method: () => {
     console.log(1)
     }
     }*/
    render() {
        const {btnContent} = this.props;

        return (
            <div className={`liveroom-setting-page-bottombtn`}>
                <div className="bottom-btn" onClick={btnContent.method}>
                    {btnContent.text}
                </div>
            </div>
        )
    }
}

export default BottomBtn


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/BottomBtn.js